import Helper from '@ember/component/helper';
import { service } from '@ember/service';
export default class PreferredWeekStartsOn extends Helper {
  @service intl;

  compute() {
    return this.intl.generatedLocaleData.firstDayOfWeek;
  }
}
